import { lazy } from 'react';

export const PlayerCancelSelfExclusionForm = lazy(
  () => import('./PlayerCancelSelfExclusionForm'),
);
